<template>
  <div v-if="loaded">
    <h2>
      Dodajte novo inventuro:
    </h2>

    <MyCompanyInventoryFormsForm
      @save="save"
      @cancel="cancel"
      ref="form"
    />
    <ConfirmDialog
      ref="confirmdialogunsaved"
      title="Opozorilo"
      text="Ali želiš izhod brez shranjevanja podatkov?"
      okBtnText="Razumem"
      :normal="false"
      v-model="showWarningModal"
    />
    <!-- Izpolni novo inventuro:
    <v-row>
      <v-col>
        <CurrentStockSearchForm
          :inventory="true"
          :showLoadingBtn="true"
          @change="changedate"
          :unsaved="unsavedChanges"
          :disableLoadingBtn="disableLoadingBtn"
          @getCurrentStockData="getCurrentStockData"
          @submit="save"
          @print="print"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-checkbox
          hide-details
          color="#0F998E"
          v-model="is_reset"
          label="Upoštevaj kot začetno stanje"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th>
                  Artikel
                </th>
                <th>
                  Skupina
                </th>
                <th>
                  ME
                </th>
                <th>
                  Vnos
                </th>
                <th>
                  Rač. zaloga
                </th>
                <th>
                  Razlika
                </th>
                <th>
                  PNC
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody v-if="loaded">
              <InventoryFormArticleRow
                v-for="(article, index) in indexedStock"
                :ref="`inventoryformarticlerow-${index}`"
                :key="index"
                :article="article"
                :new="true"
                @setCurrent="setCurrent"
                @delete="deleteArticle(index)"
                @update="updateArticleRowInLocalArray(index, $event)"
                @save="addArticleRowToLocalArray"
              />
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="7">
                  <AppSpinner />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <div ref="bottomOfThePage" style="height: 50px;"></div>
    <PopupArticleCard
      ref="popupArticleCard"
      :articleId="popupArticleCardArticle"
    /> -->
  </div>
  <div v-else style="width: 100%">
    <AppSpinner />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { objectToArray } from '@/utils/object'
import MyCompanyInventoryFormsForm from '@/components/MyCompanyInventoryFormsForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import ConfirmDialog from '@/components/ConfirmDialog'
import CurrentStockSearchForm from '@/components/CurrentStockSearchForm'
import InventoryFormArticleRow from '@/components/InventoryFormArticleRow'
import PopupArticleCard from '@/components/PopupArticleCard'

export default {
  components: {
    CurrentStockSearchForm,
    PopupArticleCard,
    InventoryFormArticleRow,
    MyCompanyInventoryFormsForm,
    ConfirmDialog
  },
  mixins: [
    asyncDataStatus
  ],
  computed: {
    indexedStock () {
      let sort = 0
      if (!this.currentStock.articles) return this.currentStock
      return this.currentStock.articles
      .sort((a, b) => a.article_name < b.article_name ? -1 : 1)
      .sort((a, b) => a.category_name < b.category_name ? -1 : 1).map(article => {
        const item = {
          ...article,
          sort: sort
        }
        sort++
        return item
      })
    }
  },
  data () {
    return {
      currentStock: [],
      localEndDate: null,
      showDeleteAcceptanceFormModal: false,
      deleteAcceptanceForm: null,
      popupArticleCardArticle: null,
      localArticles: {},
      currentArticle: null,
      showWarningModal: false,
      unsavedChanges: false,
      disableLoadingBtn: false,
      is_reset: false,
      loaded: false
    }
  },
  methods: {
    ...mapActions('currentStock', { loadCurrentStockData: 'loadItems', }),
    ...mapActions('inventoryForms', ['saveItem', 'saveArticles']),
    getCurrentStockData () {
      if (!this.localEndDate) this.localEndDate = moment().format('YYYY-MM-DD')
      this.loaded = false
      this.loadCurrentStockData({ filters: { dateTo: moment(this.localEndDate).format('YYYY-MM-DD') } })
        .then(res => {
          this.currentStock = objectToArray(res)[0]
          // this.asyncDataStatus_fetched()
          this.disableLoadingBtn = true
          this.loaded = true
        })
    },
    changedate (date) {
      this.localEndDate = date
    },
    addArticleRowToLocalArray (article) {
      article.saving = true
      // console.log(article)
      this.localArticles[article.article] = {
        price: article.price,
        quantity: article.quantity,
        article: article.article
      }
      const index = this.currentArticle + 1
      this.unsavedChanges = true
      const geenrated = `inventoryformarticlerow-${index}`
      /* mogoce bi celo hotu
        ce si na zadnjem gumbu in je trenutni
        index enak velikosti localArticles - 1
        potem bi provu fokusirat Shrani ? */
      this.$refs[geenrated][0].$refs.new_quantity.focus()
    },
    setCurrent (toSet) {
      this.currentArticle = toSet
    },
    save (form) {
      /* if (!this.unsavedChanges) return */
      this.showWarningModal = false
      this.saveItem({ id: null, date: form.data.date, comment: form.data.comment, is_reset: this.is_reset })
        .then(inventoryId => {
          this.$router.push({ name: 'MyCompanyInventoryFormsEdit', params: { id: inventoryId.id, newEntry: true } })
          /* this.saveArticles({ inventoryId: inventoryId.id, item: { articles: objectToArray(this.localArticles) } })
            .then((item) => {
              this.$router.push({ name: 'MyCompanyInventoryFormsEdit', params: { id: item.id } })
            }) */
        })
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyInventoryForms' })
    },
    print (form) {
      const filters = {
        dateTo: form.endDate,
        reportType: form.reportType
      }
      if (form.selectedCategoryIds && form.selectedCategoryIds.length && !form.selectedCategoryIds.includes(null)) {
        filters.categories = form.selectedCategoryIds.join(',')
      }

      let routeData = this.$router.resolve({ name: 'MyCompanyCurrentStockPreview', query: filters })
      window.open(routeData.href, '_blank')
    },
    openArticleCard (article) {
      this.popupArticleCardArticle = article
      this.$refs.popupArticleCard.open()
    }
  },
  created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
    } else {
      this.loaded = true
      this.showWarningModal = false
      this.asyncDataStatus_fetched()
      /* this.loaded = false
      this.loadCurrentStockData({ filters: { dateTo: moment().format('YYYY-MM-DD') } })
        .then(res => {
          // console.log('Loaded: ?!')
          this.currentStock = objectToArray(res)[0]
          this.asyncDataStatus_fetched()
          this.loaded = true
        }) */
    }
  },
  async beforeRouteLeave (to, from, next) {
    if (to.name === 'MyCompanyInventoryFormsEdit' || to.name === 'MyCompanyInventoryForms') {
      next()
    } else {
      this.showWarningModal = true
      next(await this.$refs.confirmdialogunsaved.pop())
    }
  }
}
</script>
